import { TextInput } from '@mantine/core';
import { useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import useGetUser from 'hooks/useGetUser';

const NameInput = () => {
    const intl = useIntl();
    const user = useGetUser();

    const name = `${user?.firstName} ${user?.lastName}`;

    return (
        <TextInput
            id="name-input-in-settings"
            label={intl.formatMessage(sharedMessages.nameAndSurname)}
            disabled
            value={name}
            size="md"
        />
    );
};

export default NameInput;
